var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOffGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2723_13400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "#636874",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.055 7.05762C6.80481 7.30763 6.66419 7.64679 6.66406 8.00048C6.66394 8.35417 6.80432 8.69343 7.05433 8.94362C7.30434 9.19381 7.6435 9.33443 7.99719 9.33455C8.35089 9.33468 8.69015 9.19429 8.94033 8.94428",
    stroke: "#636874",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.57 11.5657C10.4827 12.299 9.29336 12.6664 7.9987 12.6664C5.33203 12.6664 3.11003 11.111 1.33203 7.99971C2.2447 6.40305 3.27403 5.21638 4.42003 4.43905M6.2407 3.57638C6.81231 3.41286 7.40416 3.33094 7.9987 3.33305C10.6654 3.33305 12.8874 4.88838 14.6654 7.99971C14.1467 8.90705 13.5907 9.68238 12.9967 10.325L6.2407 3.57638Z",
    stroke: "#636874",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2723_13400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffGrey);
export default __webpack_public_path__ + "static/media/eye-off-grey.ff680f07ecc0fb43abaab1988a16c6a6.svg";
export { ForwardRef as ReactComponent };